import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import SafeUrlAssembler from 'safe-url-assembler';
import { ApiEndpointService } from '../../../core/services/api-endpoint.service';

@Injectable({ providedIn: 'root' })
export class ChangePasswordService {
    public constructor(private http: HttpClient,
                       private apiEndpointService: ApiEndpointService,
    ) {
    }

    public validatePassword(username: string, password: string): Observable<boolean> {
        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('validatePassword'))
            .toString();
        const data = { username, password };

        return this.http.post<{ Authentication: boolean }>(endpoint, data).pipe(
            map(result => result?.Authentication),
        );
    }

    public updatePassword(username: string, password: string): Observable<boolean> {
        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('updatePassword'))
            .toString();
        const data = { username, password };

        return this.http.post<{ Authentication: boolean }>(endpoint, data).pipe(
            map(result => result?.Authentication),
        );
    }
}
